import React from 'react';
import PropTypes from 'prop-types';

import {googleSearchLink} from '../../helpers/links';
import Linkout from './Linkout';


class GoogleLink extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Linkout url={googleSearchLink(this.props.query)} label="google" disabled={this.props.disabled}/>
        );
    }

}

GoogleLink.propTypes = {
    query: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};

export default GoogleLink;
